import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { Button } from '@cube3/cubicle/src/core/atoms/Button';
import { isMobile } from 'react-device-detect';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonGroup: {
      display: 'flex',
      marginTop: 24
    },
    mobilebuttonGroup: {
      display: 'flex',
      marginTop: 12
    },

    copyButton: { marginRight: 24 }
  })
);
export const CopyPasteButtonsUI = ({
  onCopy,
  onPaste,
  copyDisabled,
  pasteDisabled
}) => {
  const classes = useStyles();
  return (
    <div className={isMobile ? classes.mobilebuttonGroup : classes.buttonGroup}>
      <Button
        label="Copy all values"
        onClick={onCopy}
        size={isMobile ? SizeVariants.lg : SizeVariants.md}
        background="secondary"
        buttonStyle="ghost"
        disabled={copyDisabled}
        iconLeft="copy"
      />
      <Button
        label="Paste all values"
        onClick={onPaste}
        disabled={pasteDisabled}
        size={isMobile ? SizeVariants.lg : SizeVariants.md}
        background="secondary"
        buttonStyle="ghost"
        iconLeft="clipboard"
      />
    </div>
  );
};
